module.exports = {};


//////////////////
// WEBPACK FOOTER
// C:/firebase/gbord/~/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = 0